//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// @ is an alias to /src
/*import SearchBox from './components/search-result-page/SearchBox.vue';
import CategoryTag from './components/search-result-page/CategoryTag.vue';
import HostedPrograms from './components/search-result-page/HostedPrograms.vue';
import FavoriteCard from './components/search-result-page/FavoriteCard.vue';
import RequestCard from './components/search-result-page/RequestCard.vue';
import FeaturedMember from './components/search-result-page/FeaturedMember';
import LoadingComponent from './components/search-result-page/LoadingComponent.vue';*/

/*

const Companies = () => ({
    component: import("./components/search-result-page/Companies.vue"),
    loading: LoadingComponent,
    delay: 0,
});

const SideBarBlock = () => ({
    component: import("./components/search-result-page/SideBar.vue"),
    loading: LoadingComponent,
    delay: 0,
});
*/

import { referer } from '~/mixins/referer'
import { mapGetters, mapActions } from 'vuex'
import {tracksearch} from '~/mixins/tracksearch'

export default {

    key(route) {
        return 'search-page'
    },

    matomo(from, to, store) {
        return false
    },

    name: 'Search',

    mixins: [tracksearch],

    scrollToTop: true,

    loading: false,

    props: {
        type: {
            type: String,
        },
        country: {
            type: String,
        },
        term: {
            type: String,
        },
        slug: {
            type: String,
        },
        page: {
            type: String,
            default: "1"
        },
        seo: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            isFixed: false,
            show: false,
            metaLinks: [],
            showTop: 5,
            renderedOn: false,
            seoFilter: '',
            seoCountry: '',
            seoCountrySlug: '',
            headPage: {},
        }
    },

    head() {

        let headObj = this.$head()
            .setPage(this.headPage)
            .setBodyAttrs('search-css')
            .setCanonicalUrl(this.canonicalURL);

        if(this.type === 'name') {
            headObj.noindex()
        } else {
            headObj.addLinks(this.metaLinks)
        }

        return headObj.get()

    },

    created() {
        if(process.client) {
            //this.$bus.$on('track/run', this.trackSearch())
        }
    },

    destroyed() {
        if(process.client) {
            this.$bus.$off('track/run', this.trackSearch)
        }
    },

    mounted() {

        if(this.renderedOn === 'server') {
            //this.trackSearch()
        }

        if(process.client) {
            this.$bus.$on('track/run', this.trackSearch)
        }

    },

    watch: {

        '$route.query': '$fetch',

        '$fetchState.pending'(newState, oldState) {
            if(newState === true) {
                //console.log('tracking/status', 'waiting')
                this.$meta().pause()
                this.$store.commit('tracking/status', 'waiting')
            } else {
                //console.log('tracking/status', 'ready')
                this.$store.commit('tracking/status', 'ready')
                this.$meta().resume()
            }
        }
    },

    //fetchOnServer: false,

    async fetch() {

        this.renderedOn = process.client ? 'client' : 'server'

        this.isOpen = false

        let term, filter;

        if (this.seo === true) {
            term = this.country
            filter = this.getFilterFromSlug()
        } else {

            if(this.type === 'name') {
                term = this.queryQ
            } else {
                term = this.term
            }

            filter = this.queryFilter
        }


        var payload = {type: this.type, page: this.page, term: term, country: this.country, slug: this.slug, filter: filter, seo: this.seo}

        try {
            const response = await this.doSearch(payload)

            this.headPage = {
                title: this.meta.page_title,
                description: this.meta.page_description,
                shareImage: '',
                type: 'website',
            }

            if(this.seo) {
                this.getFilterFromSlug()
            }

            this.addMetaLinks()
        } catch (e) {
            this.$logger.captureExceptionAxios(e)
        }
    },


    methods: {

        ...mapActions('search', {
            doSearch: 'doSearch',
        }),

        getFilterFromSlug() {
            const params = this.slug.split('-')

            if(!params.length) {
                this.seoFilter = ''
                return false
            }

            let type = params[0]

            if(type === 'eventlocation') {
                type = 'event'
            } else if (type === 'conventionbureau') {
                type = 'cvb'
            }

            this.seoFilter = type
            this.seoCountry = this.country
            this.seoCountrySlug = params[2]

            return {'types': [type]}

        },

        trackSearch() {

            const payloadMatomo = {
                keyword: this.meta.track_keyword,
                category: this.meta.track_category,
                countResults: this.meta.total
            }

            const customDimension = {
                id: 1,
                value: this.meta.track_dimension
            }

            this.trackSearchMatomo(payloadMatomo, customDimension)
            this.trackSearchPostHog()

        },

        trackSearchPostHog() {

            let country

            if(this.meta.track_type === 'name') {
                country = null
            } else {
                country = this.meta.track_category
            }

            const params = {
                query: this.meta.track_keyword,
                category: this.meta.track_category,
                country: country,
                type: this.meta.track_type,
                results: this.meta.total,
            }

            this.$bus.$emit('provider/search', params)

        },


        addMetaLinks() {

            let links = []

            if(this.seoPaginatePrevLink) {

                links.push(            {
                    hid: 'prev',
                    rel: 'prev',
                    href: this.seoPaginatePrevLink.path
                })

            }

            if(this.seoPaginateNextLink) {

                links.push(            {
                    hid: 'next',
                    rel: 'next',
                    href: this.seoPaginateNextLink.path
                })

            }

            this.metaLinks = links

        },

        linkGen(pageNum) {

            let pagePath = this.meta.path

            if(pageNum !== 1) {
                pagePath = pagePath + '/page/' + pageNum
            }

            pagePath = this.addQueryParams(pagePath)

            return {
                path: pagePath,
            }
        },

        addQueryParams(pagePath) {

            if(this.type === 'name' || this.queryFilter) {
                pagePath = pagePath + '?'
            }

            if(this.type === 'name') {
                pagePath = pagePath + 'q=' + this.queryQ
            }

            if(this.queryFilter) {

                let add = '';
                const filter = 'filter=' + this.queryFilter

                if(this.type === 'name') {
                    add = '&'
                }

                pagePath = pagePath + add + filter
            }

            return pagePath

        },

        openMap() {
            this.currentComponent = "ShowMap"
            this.isOpen = true
        },
    },

    computed: {

        ...mapGetters('search', [
            'resultCount',
            'searchTermDisplay',
            'meta',
        ]),

        currentPage() {
            return this.meta.current_page
        },

        lastPage() {
            return this.meta.last_page
        },

        queryFilter() {
            return this.$route.query.filter
        },

        seoPaginatePrevLink() {

            if(!this.currentPage) {
                return false
            }

            if(this.currentPage == 1) {
                return false
            }

            return this.linkGen(this.currentPage-1)
        },

        seoPaginateNextLink() {

            if(!this.currentPage) {
                return false
            }

            if(this.currentPage == this.lastPage) {
                return false
            }

            return this.linkGen(this.currentPage+1)
        },

        isOpen: {
            get() {
                return this.$store.state.search.isOpen;
            },
            set(value) {
                this.$store.commit("search/isOpen", value);
            },
        },

        currentComponent: {
            get() {
                return this.$store.state.search.currentComponent;
            },
            set(value) {
                this.$store.commit("search/currentComponent", value);
            },
        },

        canonicalURL() {

           if(this.type === 'name') {
               return false
           }

            return this.meta.canonical_url
        },

        queryQ() {
            return this.$route.query.q
        }

    },

}
